const host = window.location.host;
const isDev = host.includes('localhost') || host.includes('127.0.0.1');
const apiUrl = '';
const wsUrl = isDev ? `ws://localhost:4000` : `wss://${host}`;

export const API = {
  apiBase: `${apiUrl}`,
  users: `${apiUrl}/api/users`,
  classmates: `${apiUrl}/api/classmates`,
  needs: `${apiUrl}/api/needs`,
  categories: `${apiUrl}/api/categories`,
  autoMatch: `${apiUrl}/api/auto-match`,
  reviews: `${apiUrl}/api/reviews`,
  autoModeStart: `${apiUrl}/api/auto-mode/start`,
  autoModeStop: `${apiUrl}/api/auto-mode/stop`,
  autoModeStatus: `${apiUrl}/api/auto-mode/status`,
  ws: wsUrl
};
